import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { TiMessages } from 'react-icons/ti';
import { GrClearOption } from 'react-icons/gr';
import { FaPhotoVideo } from 'react-icons/fa';


const Message = styled.div`
  /* color: red; */
  margin-top: 15px;
  .link {
    text-align: center;
    color: var(--text-color);
    background: var(--background-color);
    border-radius: 5px;
    vertical-align: bottom;
    display: inline-block;
    margin-top: 1rem;
    height: 35px;
    text-decoration: none;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
    margin-left: 10px;
    color: white;
  }
  p {
    margin-left: 10px;
    color: white;
  }
`;
const returnIcon = (icon) => {
  switch (icon) {
    case 'clear':
      return <GrClearOption className='icon' />;
    case 'photo':
      return <FaPhotoVideo className='icon' />;
      case 'message':
      return <TiMessages className='icon' />;
    default:
      return;
  }
};
const NavLinkButton = ({ text, path, icon = 'default', color }) => {
  return (
    <Message>
      <Link className='link' to={path} style={{ background: color }}>
        {returnIcon(icon)}
        <p>{text}</p>
      </Link>
    </Message>
  );
};

export default NavLinkButton;
